import { useEffect as u } from "react";
const c = _ref => {
  let {
    closeCallback: t,
    open: a,
    modalRef: n
  } = _ref;
  u(() => {
    const o = e => {
      if (!a || !n.current) return;
      if (e.key === "Escape" && t) return t();
      const r = n.current.querySelectorAll('a, button:not([disabled]), input:not([readonly]), details, select, textarea, [tabindex]:not([tabindex^="-"])');
      if (e.key !== "Tab" && e.key !== "Shift") return;
      const i = r.item(0),
        s = r.item(r.length - 1);
      !e.shiftKey && e.key === "Tab" && e.target === s && (e.preventDefault(), i.focus()), e.shiftKey && e.key === "Tab" && e.target === i && (e.preventDefault(), s.focus());
    };
    return window.addEventListener("keydown", o), () => {
      window.removeEventListener("keydown", o);
    };
  }, [t, n, a]);
};
export { c as useNavigation };